module.exports = "/dist/roboto-latin-300.svg?1edaa6e50c2302bf0221d252e1caebb4";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-300.svg
// module id = 86
// module chunks = 0